export default __webpack_public_path__ + "static/media/confirn-n-pay.3a6fd7c6.svg";